import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import EDEStatementsPage, { getDefaultPageData, getDefaultPageUI } from "components/EDEStatements/pages/EDEStatementsPage";
import Classes from "model";

/**
 * @function CaptureMabiEDEStatementsCheckingOverlay
 * @param {OBJECT} props - None used for now.
 * @description - Component for capture "003_Checking_Overlay" in mabi23 capture group "Statements".
 */
export default function CaptureMabiEDEStatementsCheckingOverlay(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const data = getDefaultPageData();
    const { accountTypes } = data ?? {};
    const { accounts } = accountTypes[0] ?? {};

    const ui = getDefaultPageUI();
    ui.EDEStatementModal = { 
        isActive: true, 
        modalID: "EDEStatementModal",
        accountID: accounts[0].id
    };

    return <EDEStatementsPage ui={ ui } />
}